/* eslint-disable max-len */
type TriangleBlueYearProps = {
  color: string
  className?: string
  strokeWidth?: string
}

export const TriangleBlueYear = ({ color, className, ...rest }: TriangleBlueYearProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="114"
      height="126"
      viewBox="0 0 114 126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M103.809 45.4964C117.143 53.1944 117.143 72.4394 103.809 80.1374L30.2977 122.579C16.9643 130.277 0.297668 120.655 0.297668 105.259V20.375C0.297668 4.97896 16.9643 -4.64352 30.2977 3.05448L103.809 45.4964Z"
        fill={drawColor}
        {...rest}
      />
    </svg>
  )
}
